import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices/DomainServicesContext";

import { collectionQueryKeys } from "./collectionQueryKeys";

// collectionId is undefined when currentOrganization is not yet loaded; the
// enabled guard prevents the query from firing until a real ID is available.
export function useCollection(collectionId: string | undefined) {
  const { collections } = useDomainServices();

  return useQuery({
    queryKey: collectionQueryKeys.detail(collectionId),
    queryFn: ({ signal }) =>
      collections.getCollectionById(collectionId!, { abortSignal: signal }),
    enabled: Boolean(collectionId),
    staleTime: 60_000,
  });
}
